import React from 'react';
import { VerseIconSVGProps } from '../typings';

export const WoohooEmoji = () => (
  <>
    <path
      d="M1.905 3.06461C1.89178 3.01663 1.93588 2.97253 1.98386 2.98575L7.14092 4.40641C7.18833 4.41947 7.20401 4.47882 7.16924 4.51359L3.43284 8.24999C3.39807 8.28476 3.33872 8.26908 3.32566 8.22167L1.905 3.06461Z"
      fill="#7EFED7"
      stroke="black"
      strokeWidth="0.5"
    />
    <circle
      cx="9.80926"
      cy="10.8899"
      r="7.32976"
      fill="#FFFD63"
      stroke="black"
      strokeWidth="0.5"
    />
    <path
      d="M13.4739 7.64386C12.898 6.80618 12.0603 6.70148 11.6414 7.27737"
      stroke="black"
      strokeWidth="0.5"
      strokeLinecap="round"
    />
    <path
      d="M6.14404 7.64386C6.71995 6.80618 7.55764 6.70148 7.97648 7.27737"
      stroke="black"
      strokeWidth="0.5"
      strokeLinecap="round"
    />
    <ellipse
      cx="12.0603"
      cy="9.68573"
      rx="1.62302"
      ry="1.62302"
      fill="white"
      stroke="black"
      strokeWidth="0.5"
    />
    <circle cx="12.06" cy="9.68569" r="0.785332" fill="black" />
    <circle cx="12.4264" cy="9.21449" r="0.314133" fill="white" />
    <ellipse
      cx="7.55783"
      cy="9.68573"
      rx="1.62302"
      ry="1.62302"
      fill="white"
      stroke="black"
      strokeWidth="0.5"
    />
    <circle cx="7.55779" cy="9.68569" r="0.785332" fill="black" />
    <circle cx="7.92448" cy="9.21449" r="0.314133" fill="white" />
    <path
      d="M12.322 13.9305C13.055 13.9305 15.3796 13.9305 16.5105 13.9305C17.6413 13.9305 18.2382 12.8833 18.2382 12.3598C18.2382 11.2079 17.3481 10.7367 16.6675 10.7891C15.9367 10.8453 15.411 11.6792 15.9345 12.4645C16.1844 12.8393 17.0898 13.0627 17.2958 12.3074C17.4529 11.7315 16.9642 11.4872 16.6675 11.4698"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12.322 13.9305C13.055 13.9305 15.3796 13.9305 16.5105 13.9305C17.6413 13.9305 18.2382 12.8833 18.2382 12.3598C18.2382 11.2079 17.3481 10.7367 16.6675 10.7891C15.9367 10.8453 15.411 11.6792 15.9345 12.4645C16.1844 12.8393 17.0898 13.0627 17.2958 12.3074C17.4529 11.7315 16.9642 11.4872 16.6675 11.4698"
      stroke="#29D4FD"
      strokeWidth="0.418844"
      strokeLinecap="round"
    />
    <path
      d="M12.322 13.9305C13.055 13.9305 15.3796 13.9305 16.5105 13.9305C17.6413 13.9305 18.2382 12.8833 18.2382 12.3598C18.2382 11.2079 17.3481 10.7367 16.6675 10.7891C15.9367 10.8453 15.411 11.6792 15.9345 12.4645C16.1844 12.8393 17.0898 13.0627 17.2958 12.3074C17.4529 11.7315 16.9642 11.4872 16.6675 11.4698"
      stroke="#7EFED7"
      strokeWidth="0.418844"
      strokeDasharray="0.42 0.42"
    />
    <path
      d="M10.542 13.2149H12.5315V14.666H10.542L10.542 13.2149Z"
      fill="#29D4FD"
      stroke="black"
      strokeWidth="0.5"
    />
    <path
      d="M10.3117 14.7595L10.1303 14.6025C10.1311 14.6015 10.1313 14.6012 10.1317 14.6C10.1323 14.5985 10.1349 14.5907 10.1349 14.5729C10.1349 14.4546 10.1123 14.4017 10.1032 14.3848C10.0985 14.3762 10.095 14.3726 10.0938 14.3714C10.0926 14.3702 10.0912 14.3691 10.089 14.3679L10.3117 14.7595ZM10.3117 14.7595L10.1303 14.6025C10.1274 14.6058 10.1102 14.6226 10.0621 14.6375C9.95565 14.6703 9.80624 14.6598 9.70758 14.6176C9.50094 14.529 9.26164 14.6247 9.17309 14.8314C9.08453 15.038 9.18026 15.2773 9.3869 15.3659C9.65469 15.4806 10.0027 15.5078 10.302 15.4155C10.4566 15.3678 10.6194 15.2814 10.746 15.1352C10.8776 14.9831 10.9491 14.7895 10.9491 14.5729C10.9491 14.3508 10.9062 14.1579 10.8189 13.9967C10.8111 13.9824 10.8031 13.9685 10.7948 13.9551C10.889 13.8172 10.9491 13.64 10.9491 13.421C10.9491 13.2119 10.9121 13.011 10.8124 12.8389C10.7076 12.6579 10.552 12.5412 10.3779 12.479C10.0673 12.3681 9.70908 12.4358 9.44623 12.5031C9.22844 12.5589 9.09712 12.7807 9.15291 12.9985C9.2087 13.2163 9.43047 13.3476 9.64826 13.2918C9.7709 13.2604 9.8723 13.2422 9.95336 13.2362M10.3117 14.7595L9.95336 13.2362M9.95584 13.8361L9.77804 13.6603C9.83424 13.6035 9.89419 13.5774 9.90899 13.5711C9.90917 13.571 9.90936 13.5709 9.90953 13.5708L9.90926 13.571L9.95584 13.8361ZM9.95584 13.8361L9.77804 13.6603C9.7463 13.6924 9.66777 13.7826 9.66056 13.927C9.65244 14.0895 9.7385 14.1988 9.79304 14.2486C9.84363 14.2948 9.89351 14.3167 9.91278 14.3247L9.95584 13.8361ZM10.0568 14.3585L10.0568 14.3585L10.0427 14.3565L10.0427 14.3565L10.0399 14.3561L10.0399 14.3561L10.039 14.356C10.034 14.3554 10.0227 14.3539 10.0127 14.3524L10.0568 14.3585ZM10.0568 14.3585C10.0734 14.3612 10.0833 14.3647 10.089 14.3679L10.0568 14.3585ZM9.95336 13.2362C10.0367 13.23 10.0828 13.2381 10.104 13.2457M9.95336 13.2362L10.104 13.2457M10.104 13.2457C10.1058 13.2463 10.1071 13.2469 10.1081 13.2473L10.104 13.2457ZM9.91279 14.3247C9.93651 14.3345 9.9564 14.3401 9.96728 14.343L9.91279 14.3247ZM9.96729 14.343C9.98857 14.3485 10.0063 14.3514 10.0127 14.3524L9.96729 14.343Z"
      fill="#FF5A52"
      stroke="black"
      strokeWidth="0.5"
      strokeLinecap="round"
    />
    <path
      d="M12 13.5C12 13.2239 12.2239 13 12.5 13C12.7761 13 13 13.2239 13 13.5V14.5C13 14.7761 12.7761 15 12.5 15C12.2239 15 12 14.7761 12 14.5V13.5Z"
      fill="#29D4FD"
      stroke="black"
      strokeWidth="0.5"
    />
  </>
);
